import type AttachmentType from 'owa-service/lib/contract/AttachmentType';
import type { AttachmentId as GraphQLAttachmentId, AttachmentTypeUnion } from 'owa-graph-schema';
import type AttachmentId from 'owa-service/lib/contract/AttachmentId';

export function convertAttachmentTypeIntoInputType(
    attachment: AttachmentType | AttachmentTypeUnion
): Omit<AttachmentType, '__type'> {
    // graphql execute complains if you provide input objects that have properties other than those defined in
    // the schema's input type. Since the AttachmentType being reused as an input type has extra fields, we need
    // to delete these in order to reuse the object as a graphql input object
    const graphQLAttachment = {
        ...attachment,
        OwsTypeName:
            (attachment as AttachmentType).__type ||
            (attachment as AttachmentTypeUnion).OwsTypeName,
    };

    delete (graphQLAttachment as AttachmentType).__type;

    if ((graphQLAttachment as AttachmentTypeUnion).__typename) {
        delete (graphQLAttachment as AttachmentTypeUnion).__typename;
    }
    if (graphQLAttachment.AttachmentId) {
        delete (graphQLAttachment.AttachmentId as GraphQLAttachmentId)['__typename'];
        delete (graphQLAttachment.AttachmentId as AttachmentId)['__type'];
    }

    return graphQLAttachment as AttachmentType;
}
